
import React from 'react';
import { FacilityOrderNewFlowUSIntakeFindAndDeleteConfirmationModalTemplate } from 'themes/application/facility-order-new-flow-us-intake/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderNewFlowUSIntakeFindAndDeleteConfirmationModalStore } from 'application/facility-order-new-flow-us-intake/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderNewFlowUSIntakeFindAndDeleteConfirmationModalStore(rootStore, componentProps), 'facilityOrderNewFlowUSIntakeFindAndDeleteConfirmationModalStore')
@observer
class FacilityOrderNewFlowUSIntakeFindAndDeleteConfirmationModal extends React.Component {
    render() {
        return <FacilityOrderNewFlowUSIntakeFindAndDeleteConfirmationModalTemplate {...this.props} />
    }
}

export default FacilityOrderNewFlowUSIntakeFindAndDeleteConfirmationModal;
